import React, { Component } from 'react';
import NavTools from '../../tools/NavTools';
import SoundRepository from '../../game/handlers/SoundRepository';
import Constants from '../../game/constants/Constants';
import MuteButton from '../../small-components/mute-button/MuteButton';
import './MenuPage.css';
import '../General.css';

class MenuPage extends Component {

    static START_COMPUTER_GAME_TIMEOUT = 50;

    constructor(props) {
        super(props);

        this.state = {
            selectedBtn: -1,
            designForChosenBtn: {
                instructions: null,
                game: null
            }
        }

        this.soundRepository = SoundRepository;
    }

    handleNavBtnClick = (pathname) => {
        this.soundRepository.playSoundByName(Constants.SOUND_BUTTON);
        let backgroundImage = require("../../media/images/icons/pink-btn.png");
        let cb = () => {
            setTimeout(() => {
                NavTools.redirect(this.props, pathname);
            }, MenuPage.START_COMPUTER_GAME_TIMEOUT);
        }
        this.setState({
            designForChosenBtn: {
                ...this.state.designForChosenBtn,
                [pathname]: {
                    border: 'none',
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "100% 100%",
                    color: "white"
                }
            }
        }, cb);
    }

    handleNavBtnClick = (pathname) => {
        this.soundRepository.playSoundByName(Constants.SOUND_BUTTON);
        NavTools.redirect(this.props, pathname, { prevUrl: '/menu' });
    }

    render() {
        return (
            <div className="menu-page page">
                <img alt="menu_pics" id="logo" draggable="false" src={require('../../media/images/icons/logo.png')} />

                <MuteButton />

                <div className="menu-btns">
                    <button className="menu-btn"
                        onClick={() => this.handleNavBtnClick('/game')}
                        style={this.state.designForChosenBtn.game}>
                        <img alt="menu_pics"
                            id="start-arrow"
                            src={require('../../media/images/icons/start-arrow.png')}
                            draggable="false" />
                        מתחילים לשחק
                    </button>
                    <button className="instrctions-temp"
                        onClick={() => this.handleNavBtnClick('/instructions')}
                        style={this.state.designForChosenBtn.instructions}>
                        הוראות
                        </button>
                </div>

                <div id="nav-bar">
                    <img alt="menu_pics"
                        id="champions"
                        className={`nav-bar-item ${this.state.selectedBtn > 0 && 'hidden'}`}
                        src={require('../../media/images/icons/champions.png')}
                        onClick={() => this.handleNavBtnClick('/champions')}
                        draggable="false" />
                    <img alt="menu_pics"
                        id="my-plate"
                        className="nav-bar-item"
                        src={require('../../media/images/icons/my-plate.png')}
                        onClick={() => this.handleNavBtnClick('/my-plate')}
                        draggable="false" />
                </div>
            </div>
        );
    }
}

export default MenuPage;
